module.exports = __webpack_public_path__ + "img/ic_mail_xsmall.b60c00b4.svg";